import React, { FunctionComponent, useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import Translation from '../../../../../../common/components/translation/Translation';
import stockStatusStyles from './stockStatusStyles';
import clsx from 'clsx';
import { StockTranslations } from '../../../../../enum/StockTranslations';

export interface IStockStatusProps {
  isInStock: boolean;
  isPreOrder: boolean;
}

const StockStatus: FunctionComponent<IStockStatusProps> = ({ isInStock, isPreOrder }) => {
  const styles = stockStatusStyles();

  const stockTranslationId = useMemo(() => {
    if (isInStock) {
      return isPreOrder ? StockTranslations.PRE_ORDER_STOCK : StockTranslations.IN_STOCK;
    }

    return isPreOrder ? StockTranslations.PRE_ORDER_NO_STOCK : StockTranslations.OUT_OF_STOCK;
  }, [isInStock, isPreOrder]);

  return (
    <Box className={styles.container} data-test="customise:stock_status">
      <Typography variant="body2" className={clsx([styles.text, isInStock ? styles.inStock : styles.noStock])}>
        {isInStock && <Box component="span" className={styles.statusIcon} />}
        <Translation id={stockTranslationId} />
      </Typography>
    </Box>
  );
};

export default StockStatus;
